import { useContext } from "react";
import { ThemeModeContext } from "../lib/AppThemeProvider";

const useThemeMode = () => useContext(ThemeModeContext);

export default useThemeMode;
